(() => {
  const KEY = 'kfaContinueShoppingUrl';
  const sameOrigin = (url) => {
    try { return new URL(url, window.location.origin).origin === window.location.origin; }
    catch (_) { return false; }
  };
  const isProductPath = (path) => /\/products\//.test(path);
  const isCartPath = (path) => /^\/cart(?:\/|$)/.test(path);
  const isUsefulSource = (url) => {
    if (!url || !sameOrigin(url)) return false;
    const parsed = new URL(url, window.location.origin);
    return !isProductPath(parsed.pathname) && !isCartPath(parsed.pathname) && !/^\/checkouts?\//.test(parsed.pathname);
  };
  const store = (url) => {
    if (!isUsefulSource(url)) return;
    const parsed = new URL(url, window.location.origin);
    sessionStorage.setItem(KEY, parsed.pathname + parsed.search + parsed.hash);
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href*="/products/"]');
    if (!link || isProductPath(window.location.pathname) || isCartPath(window.location.pathname)) return;
    store(window.location.href);
  }, true);

  if (isProductPath(window.location.pathname) && document.referrer) store(document.referrer);
  if (/^\/collections\//.test(window.location.pathname) && !isProductPath(window.location.pathname)) store(window.location.href);

  document.querySelectorAll('[data-kfa-continue-shopping]').forEach((link) => {
    const remembered = sessionStorage.getItem(KEY);
    link.href = remembered && isUsefulSource(remembered) ? remembered : (link.dataset.fallbackUrl || '/');
  });
})();

(() => {
  const STYLE_ID = 'kfa-guided-ux-style';
  const DESKTOP_FINE = window.matchMedia('(min-width: 1025px) and (hover: hover) and (pointer: fine)');

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
@media (min-width:1025px) and (hover:hover) and (pointer:fine){
  section.okd-portal .portal__left.kfa-auto-reveal-locked .portal__left-headline svg *{fill:#000!important}
  section.okd-portal .portal__left.kfa-auto-reveal-locked .portal__left-headline img{filter:brightness(0)!important}
  section.okd-portal .portal__left.kfa-auto-reveal-locked .portal__left-visual{opacity:0!important}
  section.okd-portal .portal__left.kfa-auto-reveal-locked .portal__left-copy .portal__left-claim{opacity:1!important;transition-delay:1.05s!important}
  section.okd-portal .portal__left.kfa-auto-reveal-locked .portal__left-copy .portal__left-description{opacity:1!important;transition-delay:2.55s!important}
  section.okd-portal .portal__left.kfa-auto-reveal-locked .portal__left-copy .portal__left-link--inline{opacity:1!important;transition-delay:4.05s!important}

  body.okd-style-atelir section.okd-world.kfa-auto-categories .okd-world__content .okd-world__menu{visibility:visible!important;opacity:1!important}
  body.okd-style-atelir section.okd-world.kfa-auto-categories .okd-world__menu>ul{visibility:visible!important;opacity:1!important;pointer-events:auto!important}
  body.okd-style-atelir section.okd-world.kfa-auto-categories .okd-world__menu>ul>li>ul{visibility:visible!important;opacity:1!important;pointer-events:auto!important;transition:opacity 1.35s cubic-bezier(.37,0,.63,1)!important}
  body.okd-style-atelir section.okd-world.kfa-auto-categories .okd-world__menu>ul>li:nth-child(1)>ul{transition-delay:.08s!important}
  body.okd-style-atelir section.okd-world.kfa-auto-categories .okd-world__menu>ul>li:nth-child(2)>ul{transition-delay:.24s!important}
  body.okd-style-atelir section.okd-world.kfa-auto-categories .okd-world__menu>ul>li:nth-child(3)>ul{transition-delay:.40s!important}

  body.okd-style-xposure section.okd-world .okd-world__menu>ul>li.kfa-xposure-clickable{cursor:pointer}
  body.okd-style-xposure section.okd-world .okd-world__menu>ul>li.kfa-xposure-clickable>a[href]{display:inline-flex!important;align-items:baseline;gap:.48rem;padding:.28rem 0 .34rem;border-bottom:1px solid rgba(26,26,26,.38);text-decoration:none!important}
  body.okd-style-xposure section.okd-world .okd-world__menu>ul>li.kfa-xposure-clickable>a[href]::after{content:'→';display:inline-block;color:#5d6045;font-size:.86em;font-weight:400;line-height:1;transform:translateX(0);transition:transform .26s ease}
  body.okd-style-xposure section.okd-world .okd-world__menu>ul>li.kfa-xposure-clickable:hover>a[href]::after,
  body.okd-style-xposure section.okd-world .okd-world__menu>ul>li.kfa-xposure-clickable>a[href]:focus-visible::after{transform:translateX(3px)}
}

@media (min-width:751px){
  section.kfa-exhibition-story-section .kfa-exhibition-story__works-link{font-size:.9375rem!important;font-weight:600!important;gap:.58rem!important}
  section.kfa-exhibition-story-section .kfa-exhibition-story__works-link-arrow{font-size:1.0625rem!important}
}
section.kfa-exhibition-story-section .kfa-exhibition-story__works-link.kfa-works-attention .kfa-exhibition-story__works-link-arrow{animation:kfaWorksAttention 1.25s cubic-bezier(.22,1,.36,1) .7s 1 both}
@keyframes kfaWorksAttention{0%,100%{transform:translateX(0)}38%{transform:translateX(6px)}64%{transform:translateX(1px)}}
@media (prefers-reduced-motion:reduce){section.kfa-exhibition-story-section .kfa-exhibition-story__works-link.kfa-works-attention .kfa-exhibition-story__works-link-arrow{animation:none!important}}

section.okd-portal .portal__right.kfa-xposure-panel-clickable{cursor:pointer}
`;
    document.head.appendChild(style);
  }

  function consentBlocksPortal(section) {
    const banner = section?.querySelector('#kfa-consent-banner');
    return document.documentElement.classList.contains('kfa-consent-decision-required') ||
      Boolean(banner && !banner.hasAttribute('hidden'));
  }

  function restartVideo(panel) {
    const video = panel?.querySelector('.portal__left-visual video');
    if (!video) return;
    try {
      if (Number.isFinite(video.duration)) video.currentTime = 0;
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(() => {});
    } catch (_) {}
  }

  function enablePortalAutomation() {
    if (!DESKTOP_FINE.matches) return;
    const section = document.querySelector('section.okd-portal');
    const left = section?.querySelector('.portal__left');
    if (!section || !left) return;

    const begin = () => {
      if (!DESKTOP_FINE.matches || consentBlocksPortal(section)) return;
      if (left.classList.contains('kfa-auto-reveal-locked')) return;
      left.classList.add('kfa-auto-reveal-locked');
      restartVideo(left);
    };

    window.setTimeout(begin, 1400);
    document.addEventListener('kfa:consent-resolved', () => {
      window.setTimeout(begin, 1400);
    }, { once: true });
  }

  function enableXposurePortalPanel() {
    const section = document.querySelector('section.okd-portal');
    const panel = section?.querySelector('.portal__right');
    if (!panel || panel.querySelector('.portal__right-hitarea')) return;

    const link = panel.querySelector('.portal__right-link a[href], .portal__right-visual a[href]');
    if (!link?.href) return;
    panel.classList.add('kfa-xposure-panel-clickable');

    panel.addEventListener('click', (event) => {
      if (consentBlocksPortal(section)) return;
      if (event.target.closest('a[href],button,input,select,textarea,details,#kfa-consent-banner')) return;
      window.location.assign(link.href);
    });
  }

  function enableAtelirWorldAutomation() {
    if (!DESKTOP_FINE.matches) return;
    const world = document.querySelector('section.okd-world');
    const main = document.querySelector('#MainContent');
    const isAtelir = document.body.classList.contains('okd-style-atelir') ||
      (main?.dataset.template || '').includes('collection.world-atelir');
    if (!world || !isAtelir) return;

    const content = world.querySelector('.okd-world__content');
    if (!content) return;

    let categoriesScheduled = false;
    const revealCategories = () => {
      if (categoriesScheduled || !world.classList.contains('kfa-atelir-nav-ready')) return;
      categoriesScheduled = true;
      window.setTimeout(() => world.classList.add('kfa-auto-categories'), 700);
    };

    revealCategories();
    const observer = new MutationObserver(revealCategories);
    observer.observe(world, { attributes: true, attributeFilter: ['class'] });

    window.setTimeout(() => {
      if (world.classList.contains('kfa-atelir-nav-ready')) {
        revealCategories();
        return;
      }
      content.dispatchEvent(new Event('mouseenter'));
    }, 1100);
  }

  function enableXposureWorldCues() {
    const world = document.querySelector('section.okd-world');
    const main = document.querySelector('#MainContent');
    const isXposure = document.body.classList.contains('okd-style-xposure') ||
      (main?.dataset.template || '').includes('collection.world-xposure');
    if (!world || !isXposure) return;

    world.querySelectorAll('.okd-world__menu > ul > li').forEach((item) => {
      const link = item.querySelector(':scope > a[href]');
      if (!link) return;
      item.classList.add('kfa-xposure-clickable');
      item.addEventListener('click', (event) => {
        if (event.target.closest('a[href]')) return;
        window.location.assign(link.href);
      });
    });
  }

  function enableAvailableWorksCue() {
    const links = Array.from(document.querySelectorAll(
      'section.kfa-exhibition-story-section .kfa-exhibition-story__works-link:not(.kfa-exhibition-story__works-link--floating)'
    ));
    if (!links.length) return;

    if (!('IntersectionObserver' in window)) {
      links.forEach((link) => link.classList.add('kfa-works-attention'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kfa-works-attention');
        observer.unobserve(entry.target);
      });
    }, { threshold: .6 });

    links.forEach((link) => observer.observe(link));
  }

  function normalisedPath() {
    return window.location.pathname
      .toLowerCase()
      .replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/, '')
      .replace(/\/+$/, '') || '/';
  }

  function footerDetailContext() {
    const path = normalisedPath();
    const atelirPages = new Set([
      '/pages/atelir-object',
      '/pages/atelir-paper',
      '/pages/atelir-case',
      '/pages/atelir-wood',
      '/pages/atelir-glass'
    ]);
    const xposurePages = new Set([
      '/pages/xposure-paper',
      '/pages/xposure-finish',
      '/pages/xposure-frames'
    ]);

    if (atelirPages.has(path) || path === '/collections/atelir-in-space') return { world: 'atelir', label: 'ATELI’R' };
    if (xposurePages.has(path)) return { world: 'xposure', label: 'XPOSURE' };
    return null;
  }

  function currentDetailTitle() {
    const heading = document.querySelector('#MainContent h1');
    if (heading?.textContent.trim()) return heading.textContent.trim();
    return document.title.split('|')[0].trim();
  }

  function hasUsableInternalReferrer() {
    if (!document.referrer) return false;
    try {
      const previous = new URL(document.referrer);
      const current = new URL(window.location.href);
      return previous.origin === current.origin && previous.pathname !== current.pathname;
    } catch (_) {
      return false;
    }
  }

  function ensureFooterDetailNav() {
    const context = footerDetailContext();
    const nav = document.querySelector('#main-menu');
    if (!context || !nav) return;
    if (nav.querySelector('[data-kfa-footer-detail-nav]')) return;

    const localePrefix = document.documentElement.lang?.toLowerCase().startsWith('de') ? '/de' : '';
    const fallback = `${localePrefix}/collections/${context.world}`;
    const backText = localePrefix ? 'ZURÜCK' : 'BACK';
    const title = currentDetailTitle();

    nav.classList.add('main-menu--exhibition');
    document.querySelector('.header__inner')?.classList.add('header__inner--exhibition');
    document.body.classList.remove('okd-style-atelir', 'okd-style-xposure');
    document.body.classList.add(`okd-style-${context.world}`);

    nav.innerHTML = `
      <ul class="okd-style-${context.world} kfa-exhibition-breadcrumb" data-kfa-footer-detail-nav>
        <li class="kfa-exhibition-breadcrumb__parent"><a href="${fallback}" data-kfa-footer-history-back>${backText}</a></li>
        <li class="kfa-exhibition-breadcrumb__current"><span aria-current="page"></span></li>
      </ul>`;
    const current = nav.querySelector('.kfa-exhibition-breadcrumb__current span');
    if (current) current.textContent = title;
  }

  function bindFooterBackCapture() {
    window.addEventListener('click', (event) => {
      const link = event.target.closest?.('[data-kfa-footer-history-back]');
      if (!link) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (hasUsableInternalReferrer()) window.history.back();
      else window.location.assign(link.href);
    }, true);
  }

  function keepFooterNavStable() {
    if (!footerDetailContext()) return;
    ensureFooterDetailNav();
    const nav = document.querySelector('#main-menu');
    if (!nav) return;
    const observer = new MutationObserver(() => ensureFooterDetailNav());
    observer.observe(nav, { childList: true });
    window.setTimeout(ensureFooterDetailNav, 500);
  }

  function initialise() {
    injectStyles();
    bindFooterBackCapture();
    enablePortalAutomation();
    enableXposurePortalPanel();
    enableAtelirWorldAutomation();
    enableXposureWorldCues();
    enableAvailableWorksCue();
    keepFooterNavStable();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
})();

/* KFA 15 SEP 2026 — tablet-touch guidance only.
   Mobile (<=749px) and fine-pointer desktop remain untouched. */
(() => {
  const TABLET_TOUCH = window.matchMedia(
    '(min-width: 750px) and (min-height: 600px) and (hover: none), ' +
    '(min-width: 750px) and (min-height: 600px) and (pointer: coarse)'
  );
  const TABLET_STYLE_ID = 'kfa-tablet-guided-ux-style';

  function isTabletTouch() {
    return TABLET_TOUCH.matches;
  }

  function injectTabletStyles() {
    if (document.getElementById(TABLET_STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = TABLET_STYLE_ID;
    style.textContent = `
@media (min-width:750px) and (min-height:600px) and (hover:none),
       (min-width:750px) and (min-height:600px) and (pointer:coarse){
  section.okd-portal .portal__left.kfa-tablet-auto-reveal .portal__left-headline svg *{fill:#000!important}
  section.okd-portal .portal__left.kfa-tablet-auto-reveal .portal__left-headline img{filter:brightness(0)!important}
  section.okd-portal .portal__left.kfa-tablet-auto-reveal .portal__left-visual{opacity:0!important}
  section.okd-portal .portal__left.kfa-tablet-auto-reveal .portal__left-copy .portal__left-claim{opacity:1!important;transition-delay:1.05s!important}
  section.okd-portal .portal__left.kfa-tablet-auto-reveal .portal__left-copy .portal__left-description{opacity:1!important;transition-delay:2.15s!important}
  section.okd-portal .portal__left.kfa-tablet-auto-reveal .portal__left-copy .portal__left-link--inline{opacity:1!important;transition-delay:3.25s!important}

  body.okd-style-atelir section.okd-world.kfa-tablet-menu-visible .okd-world__content .okd-world__menu,
  body.okd-style-xposure section.okd-world.kfa-tablet-menu-visible .okd-world__content .okd-world__menu{
    visibility:visible!important;
    opacity:1!important;
    pointer-events:auto!important;
    transition:opacity 1.05s cubic-bezier(.37,0,.63,1)!important;
  }
  body.okd-style-atelir section.okd-world.kfa-tablet-menu-visible .okd-world__content::after,
  body.okd-style-xposure section.okd-world.kfa-tablet-menu-visible .okd-world__content::after{
    opacity:1!important;
  }

  body.okd-style-atelir section.okd-world .okd-world__menu>ul>li>ul{
    display:block!important;
    position:relative!important;
    top:auto!important;
    left:auto!important;
    transform:none!important;
    padding:.8rem 0 .3rem!important;
    visibility:hidden!important;
    opacity:0!important;
    pointer-events:none!important;
    transition:opacity 1.05s cubic-bezier(.37,0,.63,1)!important;
  }
  body.okd-style-atelir section.okd-world .okd-world__menu>ul>li>ul>li:not(:last-child){margin-bottom:.46rem!important}
  body.okd-style-atelir section.okd-world.kfa-tablet-submenus-visible .okd-world__menu>ul>li>ul{
    visibility:visible!important;
    opacity:1!important;
    pointer-events:auto!important;
  }
  body.okd-style-atelir section.okd-world.kfa-tablet-submenus-visible .okd-world__menu>ul>li:nth-child(1)>ul{transition-delay:.06s!important}
  body.okd-style-atelir section.okd-world.kfa-tablet-submenus-visible .okd-world__menu>ul>li:nth-child(2)>ul{transition-delay:.18s!important}
  body.okd-style-atelir section.okd-world.kfa-tablet-submenus-visible .okd-world__menu>ul>li:nth-child(3)>ul{transition-delay:.30s!important}

  body.okd-style-xposure section.okd-world .okd-world__menu>ul>li.kfa-xposure-clickable{cursor:pointer}
  body.okd-style-xposure section.okd-world .okd-world__menu>ul>li.kfa-xposure-clickable>a[href]{
    display:inline-flex!important;
    align-items:baseline;
    gap:.48rem;
    padding:.28rem 0 .34rem;
    border-bottom:1px solid rgba(26,26,26,.38);
    text-decoration:none!important;
  }
  body.okd-style-xposure section.okd-world .okd-world__menu>ul>li.kfa-xposure-clickable>a[href]::after{
    content:'→';
    display:inline-block;
    color:#5d6045;
    font-size:.86em;
    font-weight:400;
    line-height:1;
  }
}
`;
    document.head.appendChild(style);
  }

  function tabletConsentBlocks(section) {
    const banner = section?.querySelector('#kfa-consent-banner');
    return document.documentElement.classList.contains('kfa-consent-decision-required') ||
      Boolean(banner && !banner.hasAttribute('hidden'));
  }

  function restartTabletVideo(panel) {
    const video = panel?.querySelector('.portal__left-visual video');
    if (!video) return;
    try {
      if (Number.isFinite(video.duration)) video.currentTime = 0;
      const promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(() => {});
    } catch (_) {}
  }

  function enableTabletPortalAutomation() {
    if (!isTabletTouch()) return;
    const section = document.querySelector('section.okd-portal');
    const left = section?.querySelector('.portal__left');
    if (!section || !left) return;

    const begin = () => {
      if (!isTabletTouch() || tabletConsentBlocks(section)) return;
      if (left.classList.contains('kfa-tablet-auto-reveal')) return;
      left.classList.add('kfa-tablet-auto-reveal', 'kfa-tablet-touch-active');
      section.querySelector('.portal__logo')?.classList.add('active');
      restartTabletVideo(left);
    };

    window.setTimeout(begin, 1400);
    document.addEventListener('kfa:consent-resolved', () => {
      window.setTimeout(begin, 1400);
    }, { once: true });

    const hitarea = left.querySelector('.portal__left-hitarea[href]');
    if (hitarea && hitarea.dataset.kfaTabletDirectBound !== '1') {
      hitarea.dataset.kfaTabletDirectBound = '1';
      hitarea.addEventListener('click', (event) => {
        if (!isTabletTouch() || tabletConsentBlocks(section)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        window.location.assign(hitarea.href);
      }, true);
    }
  }

  function enableTabletWorldAutomation() {
    if (!isTabletTouch()) return;
    const world = document.querySelector('section.okd-world');
    const main = document.querySelector('#MainContent');
    if (!world) return;

    const template = main?.dataset.template || '';
    const isAtelir = document.body.classList.contains('okd-style-atelir') || template.includes('collection.world-atelir');
    const isXposure = document.body.classList.contains('okd-style-xposure') || template.includes('collection.world-xposure');
    if (!isAtelir && !isXposure) return;

    if (isXposure) {
      world.querySelectorAll('.okd-world__menu > ul > li').forEach((item) => {
        if (item.querySelector(':scope > a[href]')) item.classList.add('kfa-xposure-clickable');
      });
    }

    window.setTimeout(() => {
      if (isTabletTouch()) world.classList.add('kfa-tablet-menu-visible');
    }, 650);

    if (isAtelir) {
      window.setTimeout(() => {
        if (isTabletTouch()) world.classList.add('kfa-tablet-submenus-visible');
      }, 1200);
    }
  }

  function initialiseTabletGuidance() {
    if (!isTabletTouch()) return;
    injectTabletStyles();
    enableTabletPortalAutomation();
    enableTabletWorldAutomation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseTabletGuidance, { once: true });
  } else {
    initialiseTabletGuidance();
  }
})();
